import { render, staticRenderFns } from "./BlockFixedPriceProductCard.vue?vue&type=template&id=70c516bc&scoped=true&"
import script from "./BlockFixedPriceProductCard.vue?vue&type=script&lang=js&"
export * from "./BlockFixedPriceProductCard.vue?vue&type=script&lang=js&"
import style0 from "./BlockFixedPriceProductCard.vue?vue&type=style&index=0&id=70c516bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c516bc",
  null
  
)

export default component.exports